import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAlignRight,
  faArrowRight,
  faBed,
  faCalendar,
  faCheck,
  faCheckCircle,
  faClock,
  faCopy,
  faDoorClosed,
  faEnvelope,
  faExclamationTriangle,
  faGlobe,
  faIdCard,
  faInfo,
  faInfoCircle,
  faLock,
  faPen,
  faPhone,
  faSink,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faUser,
  faUserFriends,
  faUserLock,
  faUsers,
  faWalking,
} from '@fortawesome/free-solid-svg-icons';

library.add(faTrashAlt);
library.add(faInfo);
library.add(faCalendar);
library.add(faGlobe);
library.add(faPhone);
library.add(faIdCard);
library.add(faEnvelope);
library.add(faUser);
library.add(faCheck);
library.add(faCopy);
library.add(faCheckCircle);
library.add(faTimesCircle);
library.add(faExclamationTriangle);
library.add(faArrowRight);
library.add(faDoorClosed);
library.add(faBed);
library.add(faLock);
library.add(faUserFriends);
library.add(faClock);
library.add(faUsers);
library.add(faUserLock);
library.add(faTimes);
library.add(faWalking);
library.add(faPen);
library.add(faInfoCircle);
library.add(faSink);
library.add(faAlignRight);
